import gql from 'graphql-tag';

import { LoyaltyCustomerFragment } from './fragments';

export const GetExpiringPointsByCustomerId = gql`
  query expiringPointsByCustomerId($customerId: String!) {
    loyaltyByCustomerId(customerId: $customerId) {
      customer {
        ...LoyaltyCustomerFragment
      }
      loyaltyCard {
        details {
          pointExpiry {
            expirationDate
            points
          }
        }
      }
    }
  }
  ${LoyaltyCustomerFragment}
`;
